// extracted by mini-css-extract-plugin
export default {"componentExternal":"PlayersList_componentExternal__CRsIf","delimiter":"PlayersList_delimiter__cE2R6","lastPlayer":"PlayersList_lastPlayer__61rp4"};